import * as React from "react"
import ImageSlider from "@components/ImageSlider"

const StrapiImageSlider = ({
    title, subtitle
}: GatsbyTypes.ImageSliderFragment) => {
    return <ImageSlider subtitle={subtitle || ""} title={title || ""} />
}

export default StrapiImageSlider
